export class EntityPro2doc {
public c_pro2doc_id:number | null = null;
public c_project_id:number | null = null;
public c_doc_id:number | null = null;
public c_pro2doc_reg_user:string | null = null;
public c_pro2doc_reg_at:Date | null = null;
public c_pro2doc_upd_user:string | null = null;
public c_pro2doc_upd_at:Date | null = null;
}